export abstract class BaseModel {
  public id: string
  private _persisted: boolean

  public get type(): string {
    return this.getClass().name
  }

  public get hashKey() {
    return `${this.type}${this.id}`
  }

  public getClass(): { new(): BaseModel; name: string } {
    return this['constructor'] as any
  }

  public isPersisted(): boolean {
    return !!this._persisted
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/base-model.ts